module.exports = __webpack_public_path__ + "img/image-04.e263513a.webp";